// extracted by mini-css-extract-plugin
module.exports = {"root":"buttonCard_root__ZA7aC","label":"buttonCard_label__KHLnK"};